import React, { useRef } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const MailPreviewBox = ({ mailBody, recipientMail }) => {
  const mailRef = useRef(null);
  const bodyRef = useRef(null);

  const handleCopyFromRef = (ref, label = "") => {
    if (ref.current) {
      ref.current.select();
      const success = document.execCommand("copy");
      alert(success
        ? `✅ ${label}をコピーしました！`
        : `❌ ${label}のコピーに失敗しました…`);
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      {/* 宛先メールアドレス */}
      <Typography variant="body2" sx={{ mb: 1 }}>
        📧 宛先メールアドレス
      </Typography>
      {/* <Stack direction="row" spacing={1}> */}
        <TextField
          inputRef={mailRef}
          fullWidth
          value={recipientMail}
          InputProps={{ readOnly: true }}
          sx={{ backgroundColor: "#f5f5f5", borderRadius: 1 }}
        />
        <Button
          onClick={() => handleCopyFromRef(mailRef, "メールアドレス")}
          variant="outlined"
          sx={{ mt: 2 }}
          startIcon={<ContentCopyIcon />}
        >
          メールアドレスをコピー
        </Button>
      {/* </Stack> */}

      {/* メール本文 */}
      <Typography variant="body2" sx={{ mt: 4, mb: 1 }}>
        📄 メール本文（以下をコピーしてメールに貼り付けてください）
      </Typography>

      <TextField
        inputRef={bodyRef}
        fullWidth
        multiline
        minRows={12}
        value={mailBody}
        InputProps={{ readOnly: true }}
        sx={{ backgroundColor: "#f5f5f5", borderRadius: 2 }}
      />

      <Button
        startIcon={<ContentCopyIcon />}
        variant="outlined"
        sx={{ mt: 2 }}
        onClick={() => handleCopyFromRef(bodyRef, "メール本文")}
      >
        メール本文をコピーする
      </Button>
    </Box>
  );
};

export default MailPreviewBox;

